export default __webpack_public_path__ + "static/media/envio-white.64687ddc.png";